import React, { FC, useContext, useEffect, useState } from 'react';

import { H3, Separator, Toggle, Tooltip } from '@smartshell/ui-kit';

import { ScreenSaver, SettingsLock } from 'components';
import { useIsFeatureAvailable } from 'features';
import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

import s from './SmartTV.module.scss';

export const SmartTV: FC = () => {
  const { t } = useContext(LocalizationContext);

  const {
    state: {
      settings: { screenSmartTV },
      isLoading,
    },
    actions: { setSetting },
  } = useContext(SettingsContext);

  const isAvailable = useIsFeatureAvailable('shell_skin_screensaver');

  const [isShown, setIsShown] = useState(Boolean(screenSmartTV));

  useEffect(() => {
    setIsShown(Boolean(screenSmartTV));
  }, [screenSmartTV]);

  useEffect(() => {
    if (!isShown && screenSmartTV) {
      setSetting({ alias: ESettingsAliases.SHELL_SMART_TV, value: '' });
    }
  }, [isShown]);

  return (
    <div className={s.container}>
      <div className={s.fields}>
        <Toggle
          onChange={setIsShown}
          value={isShown}
          label={t('setting.shell.screensaver_2')}
          description={t('setting.shell.screensaver.smart_tv.description_2')}
          disabled={isLoading || !isAvailable}
          variant="secondary"
          emptyBg
          className={s.toggle}
          rightContent={
            isAvailable ? (
              <Tooltip
                contentClassName={s.tooltip_content}
                content={
                  <div className={s.tooltip_frame}>
                    <H3>{t('setting.shell.screensaver.info.static')}</H3>
                    <ul className={s.tooltip_list}>
                      <li className={s.tooltip_item}>
                        <span className={s.tooltip_text}>
                          {t('setting.shell.bg.optimal')}
                        </span>
                        <span className={s.tooltip_value}>1920х1080</span>
                      </li>
                      <li className={s.tooltip_item}>
                        <span className={s.tooltip_text}>
                          {t('application.image.maxSize')}
                        </span>
                        <span className={s.tooltip_value}>
                          7 {t('setting.shell.bg.optimal.size')}
                        </span>
                      </li>
                      <li className={s.tooltip_item}>
                        <span className={s.tooltip_text}>
                          {t('application.image.format')}
                        </span>
                        <span className={s.tooltip_value}>
                          .jpg, .jpeg .png
                        </span>
                      </li>
                    </ul>
                  </div>
                }
              />
            ) : (
              <SettingsLock />
            )
          }
        />
        <Separator style={{ margin: '8px 0' }} />
      </div>
      <ScreenSaver
        disabled={!isAvailable || !isShown}
        type="smart_tv"
        group="secondary"
        fileFormat=".jpg, .png"
      />
    </div>
  );
};
